import React from "react";
import { CALENDLY_URL, BROKER_PHOTO } from "@/lib/siteData";
import { ArrowRight, ShieldCheck } from "lucide-react";

export default function Hero() {
  return (
    <section id="hero" data-testid="hero-section" className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden">
      <div className="absolute inset-0 bg-grain opacity-60 pointer-events-none" />
      <div className="absolute -top-24 -right-24 w-[520px] h-[520px] rounded-full bg-md-secondary/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-24 w-[420px] h-[420px] rounded-full bg-md-accent/10 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-center relative">
        <div className="lg:col-span-7 animate-fade-up">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-md-accent font-semibold mb-6">
            <span className="w-8 h-px bg-md-accent" />
            Courtier en assurance, crédit & placement — Mayenne & Ille-et-Vilaine
          </div>

          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-md-primary font-medium leading-[1.02] tracking-tight">
            Libérez votre <br />
            <span className="hero-underline italic">potentiel financier</span>
          </h1>

          <p className="mt-7 text-lg md:text-xl text-md-muted leading-relaxed max-w-xl">
            Assurances, crédits, placements. Un conseil personnalisé et sur-mesure
            pour particuliers, professionnels et entreprises. Je vous
            accompagne à chaque étape, simplement et sans jargon.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-cta-rdv"
              className="inline-flex items-center gap-2 bg-md-secondary hover:bg-md-secondaryHover text-white px-7 py-4 rounded-full text-base font-semibold shadow-lg shadow-md-secondary/30 transition-all hover:-translate-y-0.5 hover:shadow-xl"
            >
              Prendre rendez-vous
              <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href="#devis"
              data-testid="hero-cta-devis"
              className="inline-flex items-center gap-2 border border-md-primary/30 text-md-primary hover:bg-md-primary hover:text-white px-7 py-4 rounded-full text-base font-semibold transition-all"
            >
              Demander un devis gratuit
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-6 text-sm text-md-muted">
            <div className="flex items-center gap-2" data-testid="hero-trust-orias">
              <ShieldCheck className="w-5 h-5 text-md-accent" />
              <span>Orias n° 26006910 • ACPR</span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 relative animate-fade-up" style={{ animationDelay: "150ms" }}>
          <div className="relative">
            <div className="absolute -inset-6 bg-md-primary/5 rounded-[3rem] -rotate-3" />
            <div className="absolute -inset-2 border-2 border-md-primary rounded-[2.5rem] rotate-2" />
            <img
              src={BROKER_PHOTO}
              alt="Maël — Courtier MD Courtage"
              className="relative rounded-[2.5rem] w-full aspect-[4/5] object-cover"
              data-testid="hero-portrait"
            />
            <div className="absolute -bottom-6 -left-6 bg-white shadow-xl rounded-2xl px-5 py-4 border border-md-border">
              <div className="text-[10px] uppercase tracking-[0.2em] text-md-accent font-bold">Réponse en</div>
              <div className="font-serif text-3xl text-md-primary">24h chrono</div>
            </div>
            <div className="absolute -top-4 -right-4 bg-md-primary text-white rounded-2xl px-5 py-4 shadow-xl">
              <div className="text-[10px] uppercase tracking-[0.2em] text-md-secondary font-bold">1er rendez-vous</div>
              <div className="font-serif text-2xl">offert</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
